import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {isEqual} from 'lodash';
import { exposeMetrics, PropTypes as MetricsPropTypes } from "react-metrics";

import VideoJS from 'modules/Common/components/VideoJS';

require('./VideoPlayer.scss');

function defaultState() {
  return {
    videoError: null
  };
}

@exposeMetrics
export default class VideoPlayer extends Component {

  static contextTypes = {
    metrics: MetricsPropTypes.metrics
  }

  static propTypes = {
    src: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        type: PropTypes.string,
        src: PropTypes.string
      })
    ]),
    caption: PropTypes.string,
    placeholderImage: PropTypes.string,
    prompt: PropTypes.object,
    autoPlay: PropTypes.bool,
    button: PropTypes.shape({
      type: PropTypes.string,
      loadSrc: PropTypes.func
    }),

    onPlaying: PropTypes.func,
    onEnded: PropTypes.func,
    errorMessage: PropTypes.func,
    onError: PropTypes.func
  }

  constructor(...args) {
    super(...args);
    // The URL provided for At The Races is a getter for a short lived Video URL, so it must be stored transiently.
    this.state = defaultState();
    this.hasPlayed = false;
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props, nextProps)) {
        this.setState(defaultState());
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);
  }

  onVideoPlayed() {
    if (!this.hasPlayed) {
      this.hasPlayed = true;
      this.context.metrics.track("playVideo", { videoUri: this.props.caption });
    }

    if (this.props.onPlaying) {
      this.props.onPlaying();
    }
  }

  prompt() {
    const {
      prompt: {
        className,
        title,
        body
      } = {}
    } = this.props;

    const classList = ["video-prompt"];

    if (className) {
      classList.push(className);
    }

    return <div className={classList.join(" ")}>
      <h2>{title}</h2>
      {body}
    </div>;
  }

  videoPlayer() {
    const playerProps = {
      onPlaying: () => this.onVideoPlayed(),
      onEnded: evt => this.props.onEnded && this.props.onEnded(evt),
      onError: (evt, player) => {
        this.setState({videoError: player.error()});
        this.props.onError && this.props.onError(evt)
      },
      autoPlay: this.props.autoPlay,
      src: this.props.src,
      caption: this.props.caption
    };

    return <VideoJS {...playerProps}/>;
  }

  playButton() {
    const {
      button: {
        type = 'play',
        loadSrc
      } = {}
    } = this.props;

    return <div
      onClick={() => loadSrc()}
      className={`video-replay-placeholder-${type}`}
    ></div>;
  }

  errorMessage() {
    const {
      videoError
    } = this.state;

    let message;

    if (videoError && this.props.errorMessage) {
      message = this.props.errorMessage(videoError);
    }

    const errorPixelSrc = `/1x1.gif?type=video&id=0&cb=${Date.now()}`;

    return <div className="video-replay-error">
      <h2>Cannot Play Video</h2>
      <p>We're sorry, but {message || "we can't play this video for you"}.</p>
      <p>We will try to fix this as soon as possible, so please try again later.</p>
      <img src={errorPixelSrc} width="1" height="1"/>
    </div>;
  }

  render() {
    let content;

    if (this.props.prompt) {
      content = this.prompt();
    }
    else if(this.state.videoError) {
      content = this.errorMessage();
    }
    else if (this.props.src) {
      content = this.videoPlayer();
    }
    else if (this.props.button) {
      content = this.playButton();
    }
    else {
      // catch incorrect configuration as an error
      content = this.errorMessage();
    }

    const outerProps = {};
    const {placeholderImage} = this.props;

    if (placeholderImage) {
      outerProps.style = {
        backgroundImage: `url(${placeholderImage})`
      }
    }

    return (
      <div className="video-replay-container" id="video-player" {...outerProps}>
        <div className="video-replay-inner">
          { content }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Common/components/VideoPlayer.js